import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/logo/logo.svg";

const AboutPage: React.FC = () => {
  const { i18n } = useTranslation();
  return (
    <section
      style={{
        padding: "5rem 0",
        minHeight: "70vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
      className="container"
    >
      <Stack
        sx={{ flexDirection: { xs: "column", md: "row" } }}
        justifyContent={"space-between"}
        gap={5}
        alignItems={"center"}
        width={"100%"}
      >
        <Stack sx={{ width: { xs: "90%", md: "20%" } }}>
          <div
            style={{ width: "150px", height: "150px", margin: "0 auto 30px" }}
          >
            <img src={logo} alt="UHT Logo" width={150} height={150} />
          </div>
          <Typography
            variant="h2"
            color={"primary"}
            className="text-center w-full my-3"
          >
            UH TRAINING
          </Typography>
        </Stack>
        {i18n.language === "en" ? (
          <Typography
            sx={{ width: { xs: "90%", md: "80%" } }}
            fontSize={18}
            letterSpacing={0.5}
          >
            Unlimited Horizons for Training and Consulting, our specialty in
            personal, administrative and leadership development, Unlimited
            Horizons has contributed since in 2003 to develop individuals and
            institutions of Arab society and provide them with human and
            administrative development programs. We have team includes local and
            international expertise with professional preparation. Our clients
            constitute more than 78% of the largest companies in Syria. We train
            about 2,400 people annually. We have more than 600 licensed trainers
            in Syria and some Arab countries. The Company has extensive
            experience in individual and corporate training, and high-quality,
            award-winning training materials Global, supported by large annual
            investments in research and development. The company offers more
            than 110 different training topics in the form of workshops that
            cover the needs of individuals and institutions. In developing
            personal skills, raising the efficiency and capabilities of
            employees in institutions, and topics of supervisory and
            administrative skills. And leadership in all its fields. Unlimited
            Horizons Company has won many awards and certificates of
            appreciation, the most prominent of which is a certificate of
            appreciation from the University of Damascus, Various certificates
            of appreciation from many private Syrian universities,
            telecommunications companies, private banks, and companies
            Pharmaceutical industries, and many individuals.
          </Typography>
        ) : (
          <Typography
            sx={{ width: { xs: "90%", md: "80%" } }}
            fontSize={18}
            letterSpacing={0.5}
          >
            آفاق بلا حدود للتدريب والاستشارات الشركة المتخصصة بالتطوير الشخصي
            والإداري والقيادي، ساهمت منذ عام 2003 في تطوير أفراد ومؤسسات المجتمع
            العربي وتزويدهم ببرامج التنمية البشرية والإدارية، وقد تشكل فريق
            عملها من الخبرات المحلَّيَّة والعالمية ذات الإعداد المحترف. يشكل
            عملاءنا أكثر من %78 من قائمة أكبر الشركات في سوريا، نقوم بتدريب
            حوالي 2.400 شخص سنوياً، لدينا أكثر من 1.000. مدرّب مرخّص في سوريا
            وبعض الدول العربية. يتميز المركز بخبرة كبيرة في مجال تدريب الأفراد
            والشركات ومواد تدريب ذات جودة عالية وحائزة على جوائز عالمية، ومدعومة
            باستثمارات سنوية كبيرة في البحث والتطوير. تقدم الشركة أكثر من 110
            مواضيع تدريبية مختلفة على شكل ورشات عمل تغطي احتياجات الأفراد
            والمؤسسات في تطوير المهارات الشخصيَّة، ورفع كفاءة وقدرات الموظّفين
            في المؤسسات، ومواضيع المهارات الإشرافية والإدارية والقيادية في كافة
            مجالاتها. حازت شركة آفاق بلا حدود على العديد من الجوائز وشهادات
            التقدير من أبرزها شهادة تقدير من جامعة دمشق وشهادات تقدير مختلفة من
            الكثير الجامعات السوريّة الخاصّة، وشركات الاتصالات والمصارف الخاصة،
            وشركات الصناعات الدوائية، والكثير من الأفراد
          </Typography>
        )}
      </Stack>
    </section>
  );
};
export default AboutPage;
